"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusAuthenticationServer = void 0;
const react_1 = require("react");
const useCirrusServiceStatus_1 = require("./useCirrusServiceStatus");
function useCirrusAuthenticationServer() {
    const _a = useCirrusServiceStatus_1.useCirrusServiceStatus(), { data } = _a, res = __rest(_a, ["data"]);
    return react_1.useMemo(() => { var _a, _b, _c; return (Object.assign(Object.assign({}, res), { data: (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.serviceDetails) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : null })); }, [data, res]);
}
exports.useCirrusAuthenticationServer = useCirrusAuthenticationServer;
//# sourceMappingURL=useCirrusAuthenticationServer.js.map